import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customBaseURL, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_OFFER, GET_OFFER_SUCCESS, GET_OFFER_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getOffer({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/adib/admin/offers`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_OFFER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_OFFER_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_OFFER_ERROR, payload: error });
  }
}

export function* watchGetOffer() {
  yield takeEvery(GET_OFFER, getOffer);
}

function* getOfferSaga() {
  yield all([fork(watchGetOffer)]);
}

export default getOfferSaga;
